import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAW4YbippNWGMZMQHEc3kDKMjwLTiSU6F0",
  authDomain: "sow1-75bab.firebaseapp.com",
  projectId: "sow1-75bab",
  storageBucket: "sow1-75bab.firebasestorage.app",
  messagingSenderId: "114172267842",
  appId: "1:114172267842:web:7b4abe6d6dde6d49d64cdb",
  measurementId: "G-GXTB9941N3"
};
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
